import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';

@Component({
  name: 'bpc-public-subscription-category-card',
  components: {},
})
export default class PublicSubscriptionCategoryCard extends Vue {
  @Prop(Object) readonly item: AnyEntity;

  onActionClicked(action, row) {
    if (action === 'edit') {
      action = this.$authorizationService.hasPermissions(['manage_subscriptions'])
        ? action
        : 'show';
    }
    this.$emit('action-clicked', action, row);
  }

  get remainingSubscriptions() {
    return this.item?.remaining_subscriptions;
  }

  get isUnlimited() {
    return _.isNull(this.item?.remaining_subscriptions);
  }

  currentImgField = 'defaultConversionUrl';
  imgFail = false;

  onImgError() {
    if (this.currentImgField === 'url') {
      this.imgFail = true;
    }
    if (this.currentImgField === 'defaultConversionUrl') {
      this.currentImgField = 'url';
    }
  }

  get imgUrl() {
    if (this.imgFail) {
      if (this.$store.getters['centerSettings/backgroundUrl']) {
        return this.$store.getters['centerSettings/backgroundUrl'];
      } else if (this.$store.getters['centerSettings/logoUrl']) {
        return this.$store.getters['centerSettings/logoUrl'];
      }
      return null;
    }

    return this.item.subscription_categories[this.currentImgField];
  }

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
